export default __webpack_public_path__ + "aaa09f4be53723f37b5ab3494cfdd2d1.webp";